import twopoolSwapABI from './json/2pool/swap';
import fusdtSwapABI from './json/fusdt/swap';
import fusdtDepositABI from './json/fusdt/deposit';
import renSwapAbi from './json/ren-ftm/swap';

const multicall_address = '0xb828c456600857abd4ed6c32facc607bd0464f4f';

const poolsData = {
    '2pool': {
        swap_abi: twopoolSwapABI,
        N_COINS: 2,
        coin_precisions: [1e18, 1e6],
        wrapped_precisions: [1e18, 1e6],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        token_address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        old_gauge: '0x0a53FaDa2d943057C47A301D25a4D9b3B8e01e8E', // Unused
        gauge_address: '0x8866414733F22295b7563f9C5299715D2D76CAf4',
        underlying_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
        coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
    },
    fusdt: {
        swap_abi: fusdtSwapABI,
        N_COINS: 2,
        coin_precisions: [1e6, 1e18],
        wrapped_precisions: [1e6, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        deposit_abi: fusdtDepositABI,
        deposit_address: '0xa42bd395f183726d1a8774cfa795771f8acfd777',
        swap_address: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        token_address: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        old_gauge: '0x4f3E8F405CF5aFC05D68142F3783bDfE13811522', // Unused
        gauge_address: '0x06e3C4da96fd076b97b7ca3Ae23527314b6140dF',
        underlying_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        ],
        coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        ],
        is_meta: true,
        base_pool: '2pool',
        meta_N: 4,
        meta_precisions: [1e6, 1e18, 1e18, 1e6],
        meta_coin_precisions: [1e6, 1e18, 1e6],
        meta_wrapped_precisions: [1e6, 1e18],
        meta_coins: [
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
        all_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
            '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
            '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
        ],
    },
    'ren': {
        swap_abi: renSwapAbi,
        N_COINS: 2,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604',
        token_address: '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858',
        old_gauge: '0x6600e98b71dabfD4A8Cac03b302B0189Adb86Afb',
        gauge_address: '0xBdFF0C27dd073C119ebcb1299a68A6A92aE607F0',
        underlying_coins: [
            '0x321162Cd933E2Be498Cd2267a90534A804051b11',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x321162Cd933E2Be498Cd2267a90534A804051b11',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
    },
};

export {
    multicall_address,
    poolsData,
};
